import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Container, ContainerSubInfo, LabelInfoName, Image, LabelInfo, SubHeaderTitle, ContainerHeader, LabelSubInfo ,SubContainerButton, ContainerImage, ContainerContent, ImageMapa, LabelInfoText } from './style'
import Button from '../../components/Button/Button'
import ImgClockProtocolo from '../../assets/images/point-flux/clock-protocolo2.png'
//import ImgProtocol from '../../assets/images/point-flux/ticketPardo.png'
import logo from '../../assets/images/logo.png'
import LinkButton from '../../components/LinkButton/LinkButton'
import CurrentTime from '../../components/CurrentTime/CurrentTime'
import { fetchProtocolsDateStart } from '../../services/store/reducers/endpoints/protocolsByDate'
import { fetchSendSmsStart } from '../../services/store/reducers/endpoints/sendSms'
import {PulseLoader} from 'react-spinners'
import { css } from '@emotion/core'


const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`

class ProtocolList extends PureComponent{

  UNSAFE_componentWillMount () {
    let dateToApi = this.props.location.search
    dateToApi = dateToApi.split('?dateToApi=')[1]
    dateToApi =  dateToApi.split('&')[0]

    setTimeout(()=> {
      this.props.fetchProtocolsDateStart({
        re: this.props.registerPoint.re, 
        codempresa: this.props.home.company, 
        data: dateToApi
      })  
    }, 2000)
    
  }

  voltar(){
    window.history.back()
  }
  
  paraRegisterPoint(){
    window.location.href = '/register-point'
  }
  render() {
    const { sagaProtocolDate } = this.props 
    console.log('AHHHHHHHHHH', sagaProtocolDate)
    return (
      <Container>
        <ContainerImage>
        <ContainerImage>
        <Image src={logo} />
      </ContainerImage>
        </ContainerImage>
        <CurrentTime></CurrentTime>
        <ContainerHeader>
          <SubHeaderTitle>Veja a lista de protocolos registrados</SubHeaderTitle>
        </ContainerHeader>
        
        <ContainerContent>
        {
          sagaProtocolDate ?
            sagaProtocolDate.map((item, index) => (
              <ContainerSubInfo >
              <LabelInfo >
                <LabelSubInfo>
                <LabelInfoText >Nº: {item.protocolo}</LabelInfoText>
                <LabelInfoName >Horario: { new Date(item.horario).toLocaleTimeString().replace(' AM','') }</LabelInfoName>
                <LabelInfoName >Evento: { item.tipo }</LabelInfoName>
                </LabelSubInfo>
                <LinkButton position={ 'inherit' } link={'protocol-details?protocolo='+ item.protocolo + '&data=' + new Date(item.horario).toLocaleDateString() + '&hora=' + new Date(item.horario).toLocaleTimeString().replace(' AM','') + '&tipo=' + item.tipo}>
                <ImageMapa style={{height: '50px', margin: '5px'}} src={ImgClockProtocolo} link='protocol-details' />
                </LinkButton>
              </LabelInfo>
            </ContainerSubInfo>
            ))
          :
          <PulseLoader

          css={override}
          sizeUnit={"px"}
          size={20}
          color={'#123abc'}
          loading={true}
        />
        }
        </ContainerContent>
      
        <SubContainerButton>
          <Button width='130px'  backgroundColor='#40bbca' onClick={() => { this.voltar() }} >Voltar</Button>
        </SubContainerButton>
     </Container>
    )
  }
}


const mapStateToProps = state => ({
  registerPoint: state.registerPoint,
  home: state.home,
  pointFlow: state.pointFlow,
  sagaProtocolDate: state.sagaProtocolDate.data,
  sagaSendSms: state.sagaSendSms.data
})

const mapDispatchToProps = dispatch => ({
  fetchProtocolsDateStart: (mss) => dispatch(fetchProtocolsDateStart(mss)),
  fetchSendSmsStart: (mss) => dispatch(fetchSendSmsStart(mss))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProtocolList)